var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50998 3.02609C1.83753 2.69854 2.28178 2.51453 2.745 2.51453H8.73331C9.19654 2.51453 9.64079 2.69854 9.96834 3.02609C10.2959 3.35363 10.4799 3.79789 10.4799 4.26111V5.50867C10.4799 5.78429 10.2565 6.0077 9.98088 6.0077C9.70526 6.0077 9.48185 5.78429 9.48185 5.50867V4.26111C9.48185 4.06259 9.40298 3.87218 9.26259 3.73183C9.12221 3.59145 8.93183 3.51257 8.73331 3.51257H2.745C2.54648 3.51257 2.35608 3.59145 2.21571 3.73183C2.07533 3.87218 1.99646 4.06259 1.99646 4.26111V11.7465C1.99646 11.945 2.07533 12.1354 2.21571 12.2758C2.35608 12.4162 2.54648 12.495 2.745 12.495H8.73331C8.93183 12.495 9.12221 12.4162 9.26259 12.2758C9.40298 12.1354 9.48185 11.945 9.48185 11.7465V10.4989C9.48185 10.2233 9.70526 9.9999 9.98088 9.9999C10.2565 9.9999 10.4799 10.2233 10.4799 10.4989V11.7465C10.4799 12.2097 10.2959 12.654 9.96834 12.9815C9.64079 13.3091 9.19654 13.4931 8.73331 13.4931H2.745C2.28178 13.4931 1.83753 13.3091 1.50998 12.9815C1.18243 12.654 0.998413 12.2097 0.998413 11.7465V4.26111C0.998413 3.79789 1.18243 3.35363 1.50998 3.02609Z",
    fill: "#2C3038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6241 5.1558C11.819 4.96093 12.135 4.96093 12.3298 5.1558L14.825 7.65092C15.0199 7.84582 15.0199 8.16177 14.825 8.35667L12.3298 10.8518C12.135 11.0467 11.819 11.0467 11.6241 10.8518C11.4292 10.6569 11.4292 10.341 11.6241 10.146L13.7664 8.0038L11.6241 5.86154C11.4292 5.66664 11.4292 5.3507 11.6241 5.1558Z",
    fill: "#2C3038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45844 8.00382C5.45844 7.72823 5.68184 7.50479 5.95746 7.50479H14.4721C14.7477 7.50479 14.9711 7.72823 14.9711 8.00382C14.9711 8.27944 14.7477 8.50284 14.4721 8.50284H5.95746C5.68184 8.50284 5.45844 8.27944 5.45844 8.00382Z",
    fill: "#2C3038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.0636d531e8892a02df89a2ceadb57f37.svg";
export { ForwardRef as ReactComponent };